import {pi, tau} from "../math";

export default {
  draw: function(context, size) {
    var r = Math.sqrt(size / pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau);
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/symbol/circle.js
// module id = 396
// module chunks = 0